import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=adabc57c&scoped=true&"
import script from "./HelpCenter.vue?vue&type=script&lang=js&"
export * from "./HelpCenter.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=adabc57c&scoped=true&lang=css&"
import style1 from "./HelpCenter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adabc57c",
  null
  
)

export default component.exports